var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "system_drawer_inner" },
    [
      _c(
        "el-dropdown",
        { attrs: { trigger: "click" } },
        [
          _c("el-image", {
            staticClass: "img",
            attrs: { src: _vm.value.config.imageurl },
          }),
          _vm.list.length > 0
            ? _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                _vm._l(_vm.list, function (item, index) {
                  return _c("el-dropdown-item", { key: index }, [
                    _c("div", { staticClass: "system_drawer_dropdown" }, [
                      _c("div", {
                        staticClass: "icon",
                        style: {
                          backgroundImage: "url(" + item.imageurl + ")",
                          backgrouncolor: item.imageurl
                            ? "transparent"
                            : "#f6f6f6",
                        },
                      }),
                      _c("div", { staticClass: "name" }, [
                        _vm._v(" " + _vm._s(item.name) + " "),
                      ]),
                    ]),
                  ])
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }